import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

class Configuration {
    static accessList() {
        App.log('CONFIGURATION.ACCESS_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.ROLES.ACCESS_LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        try {
                            resolve(result.objList.sort((a, b) => a.menuId - b.menuId));
                        } catch (e) {
                            resolve(result.objList);
                        }
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static addDoctor(props) {
        App.log('CONFIGURATION.ADD_DOCTOR', App.LOG.FETCH, props);

        const body = new FormData();
        body.append('HospitalId', props.hospitalId);
        body.append('SectionId', props.sectionId);
        body.append('FirstName', props.firstName);
        body.append('LastName', props.lastName);
        body.append('Image', props.image);

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.DOCTORS.INSERT, {
                body,
                method: Tool.METHODS.POST,
                headers: Tool.headers({
                    'Accept': false,
                    'Content-Type': false,
                    'pragma': false,
                    'cache-control': false
                })
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static addHospital(props) {
        App.log('CONFIGURATION.ADD_HOSPITAL', App.LOG.FETCH, props);

        const body = {
            shortName: props.shortName,
            fullName: props.fullName,
            provinceId: props.provinceId,
            cityId: props.cityId,
            address: props.address,
            phoneNumber: props.phoneNumber,
            mobileNumber: props.mobileNumber,
            fax: props.fax,
            status: props.status
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.HOSPITALS.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static addPolicy(props) {
        App.log('CONFIGURATION.ADD_POLICY', App.LOG.FETCH, props);

        const body = {
            productTypeId: props.productTypeId,
            bloodGroupId: props.bloodGroupId,
            minStorageAmount: props.minStorageAmount,
            remainDaysToExpire: props.remainDaysToExpire,
            remainDaysToExpireCollectionDate:props.remainDaysToExpireCollectionDate
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.HOSPITAL_POLICIES.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static addRole(props) {
        App.log('CONFIGURATION.ADD_ROLE', App.LOG.FETCH, props);

        const body = {
            roleName: props.roleName,
            actionList: props.actionList || []
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.ROLES.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static addSection(props) {
        App.log('CONFIGURATION.ADD_SECTION', App.LOG.FETCH, props);

        const body = {
            hospitalId: props.hospitalId,
            name: props.name,
            status: props.status,
            ordering: props.ordering,
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.SECTIONS.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static addUser(props) {
        App.log('CONFIGURATION.ADD_USER', App.LOG.FETCH, props);

        const body = new FormData();
        if (props.provinceId) body.append('provinceId', props.provinceId);
        if (props.cityId) body.append('cityId', props.cityId);
        if (props.hospitalId) body.append('hospitalId', props.hospitalId);
        if (props.sectionId) body.append('sectionId', props.sectionId);
        if (props.username) body.append('username', props.username);
        if (props.password) body.append('password', props.password);
        if (props.firstName) body.append('firstName', props.firstName);
        if (props.lastName) body.append('lastName', props.lastName);
        body.append('nationalCode', (props.nationalCode || '').toString());
        if (props.genderID) body.append('genderID', props.genderID);
        if (props.mobileNumber) body.append('mobileNumber', props.mobileNumber);
        if (props.phoneNumber) body.append('phoneNumber', props.phoneNumber);
        if (props.email) body.append('email', props.email);
        if (props.address) body.append('address', props.address);
        if (props.status) body.append('status', 1);
        if (props.roleList) body.append('roleList', props.roleList);
        if (props.image) body.append('image', props.image);

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.USERS.INSERT, {
                body,
                method: Tool.METHODS.POST,
                headers: Tool.headers({
                    'Accept': false,
                    'Content-Type': false,
                    'pragma': false,
                    'cache-control': false
                })
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static deletePolicy(props) {
        App.log('CONFIGURATION.DELETE_POLICY', App.LOG.FETCH, props);

        const body = {
            productMaintanceConditionId: props.productMaintanceConditionId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.HOSPITAL_POLICIES.DELETE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }

    static doctorsList(props) {
        App.log('CONFIGURATION.DOCTORS_LIST', App.LOG.FETCH, props);

        const body = {
            hospitalId: props?.hospitalId || null,
            sectionId: props?.provinceId || null
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.DOCTORS.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static hospitalsList() {
        App.log('CONFIGURATION.HOSPITALS_LIST', App.LOG.FETCH);

        const body = {
            hospitalId: null
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.HOSPITALS.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static policyList() {
        App.log('CONFIGURATION.POLICY_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.HOSPITAL_POLICIES.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static rolesList() {
        App.log('CONFIGURATION.ROLES_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.ROLES.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static sectionsList() {
        App.log('CONFIGURATION.SECTIONS_LIST', App.LOG.FETCH);

        const body = {
            sectionId: null
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.SECTIONS.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static updateDoctor(props) {
        App.log('CONFIGURATION.UPDATE_DOCTOR', App.LOG.FETCH, props);

        const body = new FormData();
        body.append('DocterId', props.doctorId);
        body.append('HospitalId', props.hospitalId);
        body.append('SectionId', props.sectionId);
        body.append('FirstName', props.firstName);
        body.append('LastName', props.lastName);
        if (props.image)
            body.append('Image', props.image);

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.DOCTORS.UPDATE, {
                body,
                method: Tool.METHODS.POST,
                headers: Tool.headers({
                    'Accept': false,
                    'Content-Type': false,
                    'pragma': false,
                    'cache-control': false
                })
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static updateHospital(props) {
        App.log('CONFIGURATION.UPDATE_HOSPITAL', App.LOG.FETCH, props);

        const body = {
            hospitalId: props.hospitalId,
            shortName: props.shortName,
            fullName: props.fullName,
            provinceId: props.provinceId,
            cityId: props.cityId,
            address: props.address,
            phoneNumber: props.phoneNumber,
            mobileNumber: props.mobileNumber,
            fax: props.fax,
            status: props.status
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.HOSPITALS.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static updatePolicy(props) {
        App.log('CONFIGURATION.UPDATE_POLICY', App.LOG.FETCH, props);

        const body = {
            productMaintanceConditionId: props.productMaintanceConditionId,
            productTypeId: props.productTypeId,
            bloodGroupId: props.bloodGroupId,
            minStorageAmount: props.minStorageAmount,
            remainDaysToExpire: props.remainDaysToExpire,
            remainDaysToExpireCollectionDate: props.remainDaysToExpireCollectionDate
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.HOSPITAL_POLICIES.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static updateRole(props) {
        App.log('CONFIGURATION.UPDATE_ROLE', App.LOG.FETCH, props);

        const body = {
            roleId: props.roleId,
            roleName: props.roleName,
            actionList: props.actionList || []
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.ROLES.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static updateSection(props) {
        App.log('CONFIGURATION.UPDATE_SECTION', App.LOG.FETCH, props);

        const body = {
            sectionId: props.sectionId,
            hospitalId: props.hospitalId,
            name: props.name,
            status: props.status,
            ordering: props.ordering
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.SECTIONS.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static updateUser(props) {
        App.log('CONFIGURATION.UPDATE_USER', App.LOG.FETCH, props);

        const body = new FormData();
        if (props.userId) body.append('userId', props.userId);
        if (props.provinceId) body.append('provinceId', props.provinceId);
        if (props.cityId) body.append('cityId', props.cityId);
        if (props.hospitalId) body.append('hospitalId', props.hospitalId);
        if (props.sectionId) body.append('sectionId', props.sectionId);
        if (props.username) body.append('username', props.username);
        if (props.password) body.append('password', props.password);
        if (props.firstName) body.append('firstName', props.firstName);
        if (props.lastName) body.append('lastName', props.lastName);
        body.append('nationalCode', (props.nationalCode || '').toString());
        if (props.genderID) body.append('genderID', props.genderID);
        if (props.mobileNumber) body.append('mobileNumber', props.mobileNumber);
        if (props.phoneNumber) body.append('phoneNumber', props.phoneNumber);
        if (props.email) body.append('email', props.email);
        if (props.address) body.append('address', props.address);
        if (props.roleList)
            for(const item of props.roleList)
                body.append('roleList[]', item);
        if (props.status) body.append('status', props.status);
        if (props.image) body.append('image', props.image);

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.USERS.UPDATE, {
                body: body,
                method: Tool.METHODS.POST,
                headers: Tool.headers({
                    'Accept': false,
                    'Content-Type': false,
                    'pragma': false,
                    'cache-control': false
                })
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static usersList(props) {
        App.log('CONFIGURATION.USERS_LIST', App.LOG.FETCH, props);

        const body = {
            hospitalId: props?.hospitalId || null,
            provinceId: props?.provinceId || null,
            cityId: props?.cityId || null
        };

        return new Promise((resolve, reject) => {
            fetch(Api.CONFIGURATION.USERS.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

export default Configuration;